export enum OrderPaymentMethodEnum {
  cash = 'cash',
  credit_card = 'credit_card',
  debit_card = 'debit_card',
  food_voucher = 'food_voucher',
  pix = 'pix',
  sem_parar = 'sem_parar',
  other = 'other',
  loyalty = 'loyalty',
  picpay_qr_code = 'picpay_qr_code',
  mercado_pago_qr_code = 'mercado_pago_qr_code',
  pede_pronto_qr_code = 'pede_pronto_qr_code',
  ame_qr_code = 'ame_qr_code',
  digital_wallet = 'digital_wallet',
}

export enum OrderPaymentFormattedMethodEnum {
  cash = 'Dinheiro',
  credit_card = 'Cartão de Crédito',
  debit_card = 'Cartão de Débito',
  food_voucher = 'Vale Alimentação',
  pix = 'Pix',
  sem_parar = 'Sem Parar',
  other = 'Outros',
  loyalty = 'Fidelidade',
  picpay_qr_code = 'QR Code Pic Pay',
  mercado_pago_qr_code = 'QR Code Mercado Pago',
  pede_pronto_qr_code = 'QR Code Pede Pronto',
  ame_qr_code = 'QR Code Ame',
  digital_wallet = 'Carteira Digital',
}
